module.exports = __webpack_public_path__ + "static/ironharvest-32e9cd3dc38104cd2bc616553640556d.jpg";